import React from 'react';
import PropTypes from 'prop-types';

export default class ListingContentWrapper extends React.PureComponent {

    render() {
        return (
            <div>
                {this.props.isInitialRequestFulfilled && this.props.itemsCount === 0 ?
                    <div className="listing__empty-result">
                        <div className="listing__empty-result-title"
                             dangerouslySetInnerHTML={{__html: this.props.emptyResult.title}}/>
                        <div className="listing__empty-result-message"
                             dangerouslySetInnerHTML={{__html: this.props.emptyResult.text}}/>
                        {this.props.emptyResult.button ? (
                        <a href={this.props.emptyResult.button.url} className="btn btn--green btn--m-full">
                            <span className="btn__wrap" dangerouslySetInnerHTML={{__html: this.props.emptyResult.button.text}}/>
                        </a>) : null
                        }
                    </div>
                    : this.props.children
                }
            </div>
        );
    }
}

ListingContentWrapper.defaultProps = {
    emptyResult: {
        title: 'no luck here!',
        text: '<p>i am afraid we don\'t have any items<p/><p>please try making your search a little wider</p>'
    }
};

ListingContentWrapper.propTypes = {
    isInitialRequestFulfilled: PropTypes.bool.isRequired,
    itemsCount: PropTypes.number.isRequired,
    emptyResultTitle: PropTypes.string,
    emptyResultMessage: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/components/listing/js/ListingContentWrapper.js